import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

// 500번대 에러 상태 코드와 설명 매핑
const SERVER_ERROR_TYPES = {
  500: { name: "internal_server_error", description: "Internal Server Error" },
  501: { name: "not_implemented", description: "Not Implemented" },
  502: { name: "bad_gateway", description: "Bad Gateway" },
  503: { name: "service_unavailable", description: "Service Unavailable" },
  504: { name: "gateway_timeout", description: "Gateway Timeout" },
  505: {
    name: "http_version_not_supported",
    description: "HTTP Version Not Supported",
  },
  506: {
    name: "variant_also_negotiates",
    description: "Variant Also Negotiates",
  },
  507: { name: "insufficient_storage", description: "Insufficient Storage" },
  508: { name: "loop_detected", description: "Loop Detected" },
  509: {
    name: "bandwidth_limit_exceeded",
    description: "Bandwidth Limit Exceeded",
  },
  510: { name: "not_extended", description: "Not Extended" },
  511: {
    name: "network_authentication_required",
    description: "Network Authentication Required",
  },
};

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0.2,
  environment: process.env.REACT_APP_ENV || "development",

  beforeSend(event, hint) {
    const error = hint.originalException;
    let statusCode = null;

    if (error) {
      statusCode = error.status || error.statusCode || error.response?.status;

      if (!statusCode && error.message) {
        const match = error.message.match(/\b5\d{2}\b/);
        if (match) {
          statusCode = parseInt(match[0]);
        }
      }
    }

    if (statusCode && statusCode >= 500 && statusCode <= 599) {
      const errorType = SERVER_ERROR_TYPES[statusCode] || {
        name: `server_error_${statusCode}`,
        description: `Server Error ${statusCode}`,
      };

      event.tags = {
        ...event.tags,
        error_category: "5xx_error",
        error_type: errorType.name,
        http_status: statusCode.toString(),
        http_status_group: "5xx",
        severity: statusCode === 503 ? "warning" : "error",
      };

      event.contexts = {
        ...event.contexts,
        server_error: {
          status_code: statusCode,
          error_name: errorType.name,
          error_description: errorType.description,
          timestamp: new Date().toISOString(),
          url: window.location.href,
          user_agent: navigator.userAgent,
        },
      };

      if (statusCode === 503 || statusCode === 504) {
        event.level = "warning";
      } else {
        event.level = "error";
      }

      if (error.config || error.response) {
        event.contexts.api_error = {
          endpoint: error.config?.url,
          method: error.config?.method,
          response_data: error.response?.data,
          response_headers: error.response?.headers,
        };
      }
    }

    return event;
  },

  ignoreErrors: [
    // 기존
    "ResizeObserver loop limit exceeded",
    "Non-Error promise rejection captured",

    // 네트워크 단절
    "Failed to fetch",
    "Load failed",
    "NetworkError",
    "Network request failed",
    "fetch is aborted",
    "The network connection was lost",

    // 타임아웃
    "TimeoutError",
    "Request timed out",

    // 브라우저 확장 프로그램
    /^chrome-extension:\/\//,
    /extensions\//i,

    // 기타 노이즈
    "Script error.",
  ],
});

ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
